import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useMemo, useEffect, useState } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { Icon } from "@syarahtech/ui";
import { useTranslation } from "@i18n";
import SavedSearchCard from "@/pages/saved-search/components/SavedSearchCard";
import useApi from "@hooks/useApi";
import { api__getSavedSearchList } from "@/apis/saved-search/api__getSavedSearchList";
import Loader from "@componentsShared/Loader/Loader";
import EmptySavedSearch from './components/EmptySavedSearch';
import { api_deleteSavedSearchRecord } from "@/apis/saved-search/api_deleteSavedSearchRecord";
import { toast } from "sonner";
import { trackEvents } from "@/common/events/events";
import { api__saveSearch } from "@/apis/saved-search/api__saveSearch";
import { useSession } from "@/_MiniApps/auth/AuthContext";
export var SavedSearch = function SavedSearch() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(null),
    listingData = _useState[0],
    setListingData = _useState[1];
  var _useSession = useSession(),
    remote_updateSearchHashes = _useSession.remote_updateSearchHashes,
    search_hashes = _useSession.search_hashes;
  var layoutOptions = useMemo(function () {
    return {
      hideOrangeHeadBtn: true,
      hideFooter: true,
      hideSideMenue: false,
      hideAppBanner: true,
      mobileNoLogo: true,
      hideHeaderOnmobile: true,
      headHideLinks: true,
      custommobileHeader: /*#__PURE__*/React.createElement("div", {
        className: "flex items-center px-4 py-5 bg-white border-b border-b-gray-gainsboro border-solid"
      }, /*#__PURE__*/React.createElement("div", {
        className: "en:transform en:rotate-180",
        onClick: function onClick() {
          history.back();
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "material-symbols--arrow-forward-ios-rounded",
        width: 4,
        height: 4,
        color: "#6C7A8D"
      })), /*#__PURE__*/React.createElement("div", {
        className: "text-sm flex items-center text-primary font-bold m-auto"
      }, t("البحوث المحفوظة", {
        ns: "web_common"
      })), /*#__PURE__*/React.createElement("div", {
        className: "w-4 h-4"
      }))
    };
  }, []);
  var _useApi = useApi([], function () {
      return api__getSavedSearchList();
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    data = _useApi2[2];
  useEffect(function () {
    if (data) {
      setListingData(data);
      trackEvents("save_search_list_view", {
        "save_search_count": data.length > 0 ? data.length : "0"
      });
    }
  }, [data]);
  function handleDeleteSearchCard(_x) {
    return _handleDeleteSearchCard.apply(this, arguments);
  }
  function _handleDeleteSearchCard() {
    _handleDeleteSearchCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(search_hash) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api_deleteSavedSearchRecord(search_hash);
          case 3:
            _context.next = 5;
            return remote_updateSearchHashes(search_hashes.filter(function (item) {
              return item !== search_hash;
            }));
          case 5:
            toast.success(t("تم حذف البحث", {
              ns: "saved_search"
            }), {
              position: "bottom-center",
              duration: 5000,
              style: {
                zIndex: 9999999
              }
            });
            setListingData(function (prevData) {
              return prevData.filter(function (item) {
                return item.search_hash !== search_hash;
              });
            });
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            toast.error(_context.t0.message, {
              position: "bottom-center",
              duration: 5000,
              style: {
                zIndex: 9999999
              }
            });
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 9]]);
    }));
    return _handleDeleteSearchCard.apply(this, arguments);
  }
  var buildSearchPath = function buildSearchPath(tagList) {
    var params = {};
    tagList.forEach(function (tag) {
      if (tag.type === 'range' && tag.range_values) {
        // Handle range parameters separately
        var fromKey = "".concat(encodeURIComponent(tag.filterField), "_from");
        var toKey = "".concat(encodeURIComponent(tag.filterField), "_to");
        params[fromKey] = [encodeURIComponent(tag.range_values.from)];
        params[toKey] = [encodeURIComponent(tag.range_values.to)];
      } else {
        // Group regular parameters by filterField
        var key = encodeURIComponent(tag.filterField);
        var value = encodeURIComponent(tag.id);
        if (params[key]) {
          params[key].push(value);
        } else {
          params[key] = [value];
        }
      }
    });

    // Convert grouped parameters to query string
    return Object.entries(params).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        values = _ref2[1];
      if (key.endsWith('_from') || key.endsWith('_to')) {
        // Range parameters remain separate
        return "".concat(key, "=").concat(values[0]);
      }
      // Combine multiple values with commas
      return "".concat(key, "=").concat(values.join(','));
    }).join('&');
  };
  function handleUpdateSearchCard(_x2) {
    return _handleUpdateSearchCard.apply(this, arguments);
  }
  function _handleUpdateSearchCard() {
    _handleUpdateSearchCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(updatedData) {
      var _res$data, newPath, res, _res$data2, _listingData, updatedSearchHashes, _res$data3;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            newPath = buildSearchPath(updatedData === null || updatedData === void 0 ? void 0 : updatedData.tags);
            _context2.next = 4;
            return api__saveSearch(_objectSpread(_objectSpread({}, updatedData), {}, {
              path: newPath
            }));
          case 4:
            res = _context2.sent;
            if (!((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.success) === true)) {
              _context2.next = 14;
              break;
            }
            toast.success(t("تم حفظ التعديلات بنجاح", {
              ns: "saved_search"
            }), {
              position: "bottom-center",
              duration: 5000,
              style: {
                zIndex: 9999999
              }
            });
            _listingData = _toConsumableArray((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data);
            updatedSearchHashes = _listingData.map(function (item) {
              return item === null || item === void 0 ? void 0 : item.search_hash;
            });
            setListingData(_listingData);
            _context2.next = 12;
            return remote_updateSearchHashes(updatedSearchHashes);
          case 12:
            _context2.next = 15;
            break;
          case 14:
            throw new Error((res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.errors) || "something went wrong");
          case 15:
            _context2.next = 21;
            break;
          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](0);
            console.error(_context2.t0.message);
            toast.error(_context2.t0.message, {
              position: "bottom-center",
              duration: 5000,
              style: {
                zIndex: 9999999
              }
            });
          case 21:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 17]]);
    }));
    return _handleUpdateSearchCard.apply(this, arguments);
  }
  if (loading || error) return /*#__PURE__*/React.createElement(Loader, null);
  if (!loading && !error && (listingData === null || listingData === void 0 ? void 0 : listingData.length) === 0) {
    return /*#__PURE__*/React.createElement(Layout, layoutOptions, /*#__PURE__*/React.createElement(EmptySavedSearch, null));
  }
  return /*#__PURE__*/React.createElement(Layout, layoutOptions, (listingData === null || listingData === void 0 ? void 0 : listingData.length) > 0 && /*#__PURE__*/React.createElement("section", {
    className: "px-4 py-6 flex flex-col gap-4 lg:max-w-[740px] lg:mx-auto lg:px-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block md:mb-8"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-primary text-center font-bold text-2xl"
  }, t("البحوث المحفوظة", {
    ns: "web_common"
  }))), listingData === null || listingData === void 0 ? void 0 : listingData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(SavedSearchCard, _extends({
      key: "saved-search-card-".concat(item.search_hash)
    }, item, {
      onDeleteSearchCard: function onDeleteSearchCard(search_hash) {
        return handleDeleteSearchCard(search_hash);
      },
      onUpdateSearchCard: function onUpdateSearchCard(updatedData) {
        return handleUpdateSearchCard(updatedData);
      }
    }));
  })));
};
export default SavedSearch;